// Cache busting utility
export const getCacheBuster = () => {
    // Use timestamp for cache busting
    return Date.now().toString();
};
// Version for manual cache busting
export const APP_VERSION = '1756780837691'; // Updated to force cache invalidation
// Function to append cache buster to URLs
export const addCacheBuster = (url) => {
    const separator = url.includes('?') ? '&' : '?';
    return `${url}${separator}v=${getCacheBuster()}`;
};
